export const BUYER_ROOT = "/u";

export const BUYER_HOME = BUYER_ROOT + "/home";
export const BUYER_ALL_PRODUCTS = BUYER_ROOT + "/products";
export const BUYER_PRODUCE_DETAIL = BUYER_ROOT + "/produce/:id";
export const BUYER_SEARCH = BUYER_ROOT + "/search";
export const BUYER_BIDS = BUYER_ROOT + "/bids";
